import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Formulas from "./pages/Formulas";
import Login from "./pages/Login";
import Mixer from "./pages/Mixer";
import Users from "./pages/Users";
import Lists from "./pages/Lists";
import EditFormula from "./pages/EditFormula";
import ResetPassword from "./pages/ResetPassword";
import "./css/bootstrap.css";
import "./App.css";
import LoginContext from "./context/LoginContext";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  return (
    <LoginContext.Provider value={{ isLoggedIn, setIsLoggedIn }}>
      <div className="appContainer">
        <Router>
          <header className="App-header no-print">
            <Navbar />
          </header>
          <Routes>
            <Route index element={<Navigate to="/mixer" />} />
            <Route path="/formulas" element={<Formulas />} />
            <Route path="/editFormula" element={<EditFormula />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/resetPassword/:userId/:verifyToken/"
              element={<ResetPassword />}
            />
            <Route path="/mixer" element={<Mixer />} />
            <Route path="/users" element={<Users />} />
            <Route path="/lists" element={<Lists />} />
            <Route path="/verifyEmail" />
          </Routes>
          <footer style={{ height: "50px" }}></footer>
        </Router>
      </div>
    </LoginContext.Provider>
  );
}

export default App;
